import React from 'react'
import axios from 'axios'
import maplibregl from 'maplibre-gl'
import { useGlobalState } from 'state'
import { IDs } from 'common/consts'
import dayjs from 'dayjs'
import { RoadSymbols } from 'common/consts'
import { RoadType } from 'common/types'


export const RoadRegulationLayer = () => {
  const state = useGlobalState()
  const sourceId = IDs.roadRegulation.source
  const layerId = IDs.roadRegulation.layer
  const symbolLayoutId = `${layerId}_symbol`

  const isTargetRoadType = (category: string) => {
    const targetTypes = state.app.roadRegulationTypes
    if ((category.startsWith('事前') || category.startsWith('災害') || category === '気象条件') && targetTypes.includes(RoadType.TENKI)) return true
    if (category === '工事' && targetTypes.includes(RoadType.KOUJI)) return true
    if (category.startsWith('予告') && targetTypes.includes(RoadType.YOKOKU)) return true
    if ((category === 'その他' || category === 'イベント') && targetTypes.includes(RoadType.ETC)) return true
    return false
  }

  const getFilteredFeatureCollection = async () => {
    const res = await axios.get('https://mapdata.riskma.jp/shizuoka/road_regulation.geojson')
    const features = res.data?.features ?? []
    return {
      type: 'FeatureCollection',
      features: features.filter((feature: any) => isTargetRoadType(String(feature.properties?.RGClassNM ?? '')))
    }
  }

  React.useEffect(() => {
    if (!state.mapbox) return

    load()

    state.mapbox?.on('mouseenter', symbolLayoutId, mouseEnterListener)
    state.mapbox?.on('mouseleave', symbolLayoutId, mouseLeaveListener)
    state.mapbox?.on('click', symbolLayoutId, clickListener)
    state.mapbox?.on('style.load', load)
    return () => {
      state.mapbox?.off('mouseenter', symbolLayoutId, mouseEnterListener)
      state.mapbox?.off('mouseleave', symbolLayoutId, mouseLeaveListener)
      state.mapbox?.on('click', symbolLayoutId, clickListener)
      state.mapbox?.off('style.load', load)
    }
  }, [state.mapbox])

  const mouseEnterListener = () => {
    if (!state.mapbox) return
    state.mapbox.getCanvas().style.cursor = 'pointer'
  }

  const mouseLeaveListener = () => {
    if (!state.mapbox) return
    state.mapbox.getCanvas().style.cursor = ''
  }

  const clickListener = (e: any) => {
    if (!state.mapbox) return

    const properties = e.features[0].properties
    console.log(properties)
    const startDate = dayjs(properties.StartDT).format('YYYY/MM/DD HH:mm')
    const endDate = !properties.EndDT ? '未設定' : dayjs(properties.end_date).format('YYYY/MM/DD')
    let address = properties.StartAddr
    if (address !== properties.EndAddr) {
      address += '〜' + properties.EndAddr
    }
    const publicMemo = !properties.public_memo ? '' : `<div class="memo">${properties.public_memo}</div>`
    const html = `<div class="road-regulation">
      <div class="row"><div class="title">種別</div><div>${properties.RGTypeNM}</div></div>
      <div class="row"><div class="title">原因</div><div> ${properties.RGReasonNM} ${properties.RGDetailNM}</div></div>
      <div class="row"><div class="title">期間</div><div> ${startDate} 〜 ${endDate}</div></div>
      <div class="row"><div class="title">路線</div><div> ${properties.RoadNM}</div></div>
      <div class="row"><div class="title">区間</div><div> ${address}</div></div>
      ${publicMemo}
    </div>`

    new maplibregl.Popup()
      .setLngLat(e.lngLat)
      .setHTML(html)
      .setOffset([0, -10])
      .addTo(state.mapbox)
  }

  React.useEffect(() => {
    if (!state.mapbox) return
    setLayoutvisibility()
  }, [state.app.roadRegulation])

  const setLayoutvisibility = () => {
    if (!state.mapbox) return
    state.mapbox.setLayoutProperty(
      symbolLayoutId,
      'visibility',
      state.app.roadRegulation ? 'visible' : 'none'
    )
  }

  React.useEffect(() => {
    if (!state.map) return
    if (!state.map.hasSource(sourceId)) return
    load()
  }, [state.app.roadRegulationTypes])

  const load = async () => {
    if (!state.mapbox) return

    const featureCollection = await getFilteredFeatureCollection()

    // symbol images
    RoadSymbols.forEach(row => {
      state.map.loadImage(`${sourceId}_${row.id}`, row.url, false)
    })

    // source
    if (state.map.hasSource(sourceId)) {
      state.map.updateSourceData(sourceId, featureCollection)
    } else {
      state.map.addSource(sourceId, {
        type: 'geojson',
        data: featureCollection
      })
    }

    // symbol
    if (state.map.hasLayer(symbolLayoutId)) {
      state.map.removeLayer(symbolLayoutId)
    }
    state.map.addLayer({
      id: symbolLayoutId,
      type: 'symbol',
      source: sourceId,
      layout: {
        'icon-image': ['concat', `${sourceId}_`, ['get', 'IconID']],
        'icon-size': 1,
        'icon-allow-overlap': true,
      }
    })

    setLayoutvisibility()
  }

  return (
    <></>
  )
}
